import { hideVisually } from 'polished'
import styled, { css } from 'styled-components'

const Footer = styled.footer`
  ${({ theme }) => css`
    width: 100%;
    padding: 0 ${theme.spacing(5)};
    background-color: ${theme.palette.black};
    color: ${theme.palette.white};
    // Anchor the footer to the bottom of the page in the context of the flex container
    margin-top: auto;

    ${theme.media('md')} {
      padding: 0 ${theme.spacing(10)};
    }

    &.isQuiz {
      background-color: ${theme.palette.grey[50]};
      color: ${theme.palette.black};

      ${theme.maxMedia('sm')} {
        ${hideVisually()}
      }
    }
  `}
`

const FooterInner = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 1.4rem;

    ${theme.media('md')} {
      flex-direction: row;
    }

    > nav {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: ${theme.spacing(1)} 0;

      ${theme.media('xs')} {
        gap: ${theme.spacing(2)};
        padding: 0;
      }
    }

    a,
    button {
      padding: ${theme.spacing(2)};
      flex-grow: 1;
      width: 100%;
      text-decoration: none;
      text-align: center;
      color: ${theme.palette.white};
      font-size: 1.4rem;

      ${theme.media('xs')} {
        width: auto;
      }
    }

    button {
      appearance: none;
      background-color: transparent;
      border: 0 none;
    }

    &.isQuiz {
      width: calc(100vw - ${theme.spacing(20)});
      margin: auto auto 0;
      padding: 0;
      border-top: 0.1rem solid ${theme.palette.grey[300]};

      ${theme.maxMedia('sm')} {
        ${hideVisually()}
      }

      a,
      button {
        color: ${theme.palette.black};
      }
    }
  `}
`

export default {
  Footer,
  FooterInner,
}
